export default __webpack_public_path__ + "static/media/pukanina-bl.79f4e6ca.png";